<template>
    <grid class="g-m">
<!--        <row class="dpli-h height60" :reverse="!1" middle="xs" start="xs" @click="$router.push({ path: 'events', query: { type: 'geo_zone'} })">-->
        <row class="dpli-h height60" :reverse="!1" middle="xs" start="xs" @click="getLastReport('zone_home_out')">
            <column :xs="3">
                <b>{{$t('reports.type.geo')}}</b>
            </column>
            <column :xs="7"></column>
            <column :xs="2"></column>
        </row>
        <row class="dpli-h height60" :reverse="!1" middle="xs" start="xs" @click="$router.push({ path: 'events', query: { type: 'no_response'} })">
<!--        <row class="dpli-h height60" :reverse="!1" middle="xs" start="xs" @click="getLastReport('events7')">-->
            <column :xs="9">
                <b>{{$t('reports.type.offline_days')}}</b>
            </column>
            <column :xs="3"></column>
        </row>
        <row class="dpli-h height60"  :reverse="!1" middle="xs" start="xs" @click="$router.push({path: 'reports/settings'})">
            <column :xs="2">
                <i class="far fa-cog fa-2x"></i>
            </column>
            <column :xs="6" class="align-left">
                <b>{{$t('settings.main_label')}}</b>
            </column>
            <column :xs="3"></column>
        </row>
    </grid>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Reports',
  methods: {
    ...mapActions(['getLastReport'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/Reports.vue